// extracted by mini-css-extract-plugin
export default {"rootWrapper":"AccessGroupsManagementTable_rootWrapper__4iw2i"};